import React, { useState } from "react";
import ReviewerCard from "./components/ReviewerCard";

const CardsLayout = () => {
  return <>{<ReviewerCard searchQuery={undefined} />}</>;
};

export default CardsLayout;
